import { atom } from "recoil";
import { ResponseLoginResponse } from "../../services/OpenAPI";

export const loginUserAtom = atom<{
  user: ResponseLoginResponse | null;
}>({
  key: "loginUserAtomloginUserAtom", // 一意のキーを指定
  default: {
    user: null,
  },
});
